import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { EsgConstants } from '@ddt-web/config';
import { ConfigService, InjectConfig, PaConfigKey } from '@ddt-web/config-layer';
import { ComponentData, TabData } from '@ddt-web/data-service';

import { EsgScoreImpact } from '../models';
import { EsgScoreImpactUtil } from '../utils/esg-score-impact.utils';

@Component({
	selector: 'esg-industry-involvement',
	templateUrl: './esg-industry-involvement.component.html',
	styleUrls: ['./esg-industry-involvement.component.scss']
})
export class EsgIndustryInvolvementComponent implements OnChanges {
	@InjectConfig(PaConfigKey.EsgIndustryInvolvement) private readonly industryInvolvementMetrics: any[] = EsgConstants.INDUSTRY_INVOLVEMENT_METRICS;

	@Input() public data: ComponentData;

	public industryInvolvementImpact: Array<EsgScoreImpact> = [];

	constructor(public contentService: ContentService, public configService: ConfigService) { }

	public ngOnChanges(): void {
		if (this.data?.success) {
			const tab: TabData = this.data.getTabById('esg.industryInvolvement');
			const cells = tab.tableData[0]?.cells;
			const headers = tab.tableData[0]?.headersX;

			this.industryInvolvementImpact = headers.map((header, index: number) => {
				return {
					portfolioName: header?.formattedValue,
					metrics: this.industryInvolvementMetrics.map((equivalency) => {
						const icon = EsgScoreImpactUtil.getMetricIcon(equivalency, this.contentService);
						const industryInvolvementCells = cells.find(cell => cell[0]?.config?.id === equivalency);
						const metricScore = industryInvolvementCells?.[index]?.formattedValue;
						return {
							name: equivalency,
							icon,
							metricScore,
							showUnits: false
						};
					})
				};
			});
		}
	}

}
